import React from 'react';
import { Button, FormControl, InputGroup, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
const copy = require('clipboard-copy');
import SocialMediaButtons from '../../../common/SocialMediaButtons.jsx';
import notifier from '../../../../../_utils/notifier';


const SharedModal = ({ show, onClose, name, link }) => {

  const handleClick = () => {
    copy(link);
    notifier.success(gettext('Ссылка успешно скопирована'));
  };

  return(<>
    <Modal show={ show } onHide={ onClose } size='md'>
      <Modal.Header closeButton>
        <Modal.Title>
          { gettext('Поделиться аранжировкой') }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <InputGroup className="mb-3">
          <FormControl
            placeholder={ gettext('Ссылка на аранжировку') }
            aria-label={ gettext('Ссылка на аранжировку') }
            aria-describedby="basic-addon2"
            readOnly={ true }
            value={ link }
          />
          <InputGroup.Append>
            <Button variant="outline-secondary" type="button" onClick={ handleClick }
                    title={ gettext('Скопировать ссылку') }>
              <i className="icon icon-floppy"></i>
            </Button>
          </InputGroup.Append>
        </InputGroup>
        <SocialMediaButtons name={ name } link={ link } title={ gettext('ноты и табы для гитары') }/>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={ onClose }>
          { gettext('Закрыть') }
        </Button>
      </Modal.Footer>
    </Modal>
  </>)
}

SharedModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
}


export default compose(
  connect(null, {}),
)(SharedModal);
